import {
  NgModule,
  NO_ERRORS_SCHEMA,
  CUSTOM_ELEMENTS_SCHEMA,
} from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

// components

import { FileUploaderComponent } from "./components/file-uploader/file-uploader.component";
import { ProgressBarComponent } from "./components/progress-bar/progress-bar.component";
import { HeaderEvaluateMenuComponent } from "./components/header-evaluate-menu/header-evaluate-menu.component";
import { ShowEntriesComponent } from "@app/shared/basic-components/components/show-entries/show-entries.component";
import { HeaderRouteMenuComponent } from "@app/shared/basic-components/components/header-route-menu/header-route-menu.component";
import { HeaderRouteMenuLightComponent } from "@app/shared/basic-components/components/header-route-menu-light/header-route-menu-light.component";
import { QuestionCardComponent } from "@app/shared/basic-components/components/question-card/question-card.component";
import { ShowQuestionCountComponent } from "@app/shared/basic-components/components/show-question-count/show-question-count.component";
import { QuestionSideMenuComponent } from "@app/shared/basic-components/components/question-side-menu/question-side-menu.component";

// OTHER
import { DefaultDatePipe } from "@app/shared/basic-components/pipes/default-date.pipe";

import { OnlyNumberDirective } from "@app/shared/basic-components/directives/only-number.directive";

// module
import { TableModule } from "./components/table/table.module";
import { ButtonGpModule } from "./components/button-gp/button-gp.module";
import { TextGpModule } from "./components/text-gp/text-gp.module";
import { EvaluateQuestionModule } from "./components/evaluate-question/evaluate-question.module";

// import other lib
import { CountdownModule } from "ngx-countdown";
import { TimerComponent } from "@app/shared/basic-components/components/timer/timer.component";
import { TimerIncrement } from "@app/shared/basic-components/components/timer-increment/timer-increment.component";
import { SpyScrollDirective } from "@app/shared/basic-components/directives/spy-scroll.directive";
import { GlobalToastComponent } from "./components/global-toast/global-toast.component";
import { NumberWithSpecialCharDirective } from "./directives/number-special-char.directive";
import { SafeUrl } from "@app/shared/basic-components/pipes/safe-url.pipe";

// interceptor
// import { AuthInterceptor } from 'src/interceptors/auth.interceptor';

const components = [
  TimerIncrement,
  TimerComponent,
  FileUploaderComponent,
  ShowEntriesComponent,
  HeaderRouteMenuComponent,
  HeaderRouteMenuLightComponent,
  ProgressBarComponent,
  QuestionCardComponent,
  HeaderEvaluateMenuComponent,
  ShowQuestionCountComponent,
  QuestionSideMenuComponent,
  GlobalToastComponent,
];
const pipes = [DefaultDatePipe, SafeUrl];

const directives = [
  OnlyNumberDirective,
  SpyScrollDirective,
  NumberWithSpecialCharDirective,
];

const moduleList = [
  TableModule,
  ButtonGpModule,
  TextGpModule,
  EvaluateQuestionModule,
];
@NgModule({
  declarations: [components, pipes, directives],
  imports: [CommonModule, moduleList, NgbModule, CountdownModule],
  exports: [components, moduleList, directives, pipes],
  providers: [DatePipe],
})
export class BasicModule {}
